export default __webpack_public_path__ + "static/media/health2.e1aa220e.png";